import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import { DragDropContext, Droppable, Draggable } from "@hello-pangea/dnd";
import Card from "../../../../components/cards/admin/cards";
import Input from "../../../../components/inputs/inputs";
import Button from "../../../../components/buttons/buttons";
import EmptyState from "../../../../assets/images/emptyState/food-package.svg";
import { Pagination } from "../../../../components/pagination/pagination";
import { Beat } from "../../../../plugins/spinners.plugin";
import TableSkeleton from "../../../../components/skeleton/table";
import Adjust from "../../../../assets/images/icons/adjust.svg";
import CLOSE from "../../../../assets/images/icons/close.svg";
// import {
//   getAllPackagesAction,
//   searchPackageAction,
// } from "../../../../redux/packages/packagesActions";
import { getAllPublicPackagesByFilter, searchPublicPackageAction } from "../../../../redux/publicPackages/publicPackagesActions";
import { packageArrangements } from "../../../../redux/arrangements/arrangementAction";

export const CheckBox = ({
  setPosition,
  selectId,
  setSelectId,
  pack_id,
  position,
  setShowModal,
}) => {
  return (
    <div
      onClick={() => {
        setSelectId(pack_id);
        setShowModal(true);
        setPosition(position);
      }}
      className={` w-4 h-4 text-primary bg-gray-100 rounded border
       ${
         selectId === pack_id
           ? "border-primary bg-primary"
           : "border-gray-300 dark:border-[#A1A1AA] dark:bg-[#0D0D0D]"
       }`}
    />
  );
};

export default function PackageArrangement() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { page } = useParams();

  // const { allPackages, search } = useSelector((state) => state.packages);
  const { allPackages, search, searching, isLoading } = useSelector(
    (state) => state.publicPackages
  );
  // const { isLoading, searching } = useSelector((state) => state.packages);
  const { arranging } = useSelector((state) => state.arrangement);

  const [input, setInput] = useState({
    search: "",
  });
  const [data, setData] = useState('');
  const [selectId, setSelectId] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [position, setPosition] = useState(false);
  const [packages, setPackages] = useState(allPackages?.data);
  const [active_tab, setActive_tab] = useState("all-Packages");

  useEffect(() => {
    if (!page) {
      navigate(`/admin/settings/arrangement/packages/1`);
    }
  }, [page, navigate]);

  useEffect(() => {
    dispatch(getAllPublicPackagesByFilter({ package_type: "food" }, page));
    // eslint-disable-next-line
  }, [page]);
  useEffect(() => {
    setPackages(allPackages?.data);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [allPackages]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    e.preventDefault();
    setInput({ ...input, [name]: value });
  };
  const showSearch = () => {
    if (input?.search?.length > 2) {
      setActive_tab("searched");
    }
  };
  const removeSearch = () => {
    if (input?.search?.length === 0) {
      setActive_tab("all-Packages");
      setData("");
    }
  };

  useEffect(() => {
    if (input?.search?.length > 2) {
      async function doSearch() {
        try {
          let response = await dispatch(searchPublicPackageAction(input));
          if (response?.status === "success") {
            showSearch();
          }
        } catch (error) {}
      }
      doSearch();
    } else if (input?.search?.length === 0) {
      removeSearch();
    }
    // eslint-disable-next-line
  }, [input, dispatch]);

  const handleDragEnd = (result) => {
    if (!result.destination) return;
    const items = Array.from(packages);
    const [reorderedItem] = items.splice(result.source.index, 1);
    items.splice(result.destination.index, 0, reorderedItem);
    setPackages(items);
  };

  // const handlePosition = () => {
  //   const lists = {};
  //   search?.map((list) => {
  //     lists[list.id] = parseInt(data);
  //     return list;
  //   });
  //   dispatch(packageArrangements({ list: lists }));
  //   removeSearch();
  // };

   const handlePosition = () => {
     const lists = {};
     if (active_tab === "searched") {
       console.log("search", search);
       // For search results, only update the selected package's position
       search?.data?.forEach((item) => {
         if (item.id === selectId) {
           lists[item.id] = parseInt(data);
         } else {
           lists[item.id] = item.position; // Keep existing position
         }
       });
       removeSearch(); // Only remove search when in search mode
     } else {
       // For all packages, update all items with their current positions
       packages?.forEach((item) => {
         if (item.id === selectId) {
           lists[item.id] = parseInt(data);
         } else {
           lists[item.id] = item.position; // Keep existing position
         }
       });
     }

      dispatch(packageArrangements({ list: lists }));
      setData("");
   };

  const handleSave = async () => {
    // if the page = 1, position number will start from 0,
    // else position number needs to add 1 to account for zero indexing
    const position_number = () => {
      if (page > 1) {
        let last_item = Number((page - 1) * 24);
        return last_item + 1;
      } else {
        return Number((page - 1) * 24);
      }
    };
    const lists = packages?.reduce((acc, list, i) => {
      acc[list.id] = i + position_number();
      return acc;
    }, {});
    try {
      const response = await dispatch(packageArrangements({ list: lists }));
      if (response) {
        dispatch(getAllPublicPackagesByFilter({ package_type: "food" }, page));
      }
    } catch (error) {}
  };
  return (
    <div className="relative">
      <div className=" mb-12">
        <Card.TableFilter
          results={allPackages?.to}
          title={"Food Package Arrangement"}
          totalResults={allPackages?.total}
          onChange={handleChange}
          searchPlaceholder="Store, title or subscriber"
        >
          {active_tab === "all-Packages" && (
            <Button.Primary

            disabled={data.trim() || arranging}
              title={arranging ? <Beat /> : "Save"}
              className=" w-20"
              onClick={handleSave}
            />
          )}
        </Card.TableFilter>

        <div className="border-b border-[#E4E4F3] dark:border-[#505050]" />
        {active_tab === "all-Packages" && (
          <div className="bg-white dark:bg-[#121212] rounded-md py-4">
            {isLoading ? (
              <TableSkeleton />
            ) : packages?.length > 0 ? (
              <DragDropContext onDragEnd={(results) => handleDragEnd(results)}>
                <table className="w-full text-sm text-left text-[#151515] dark:text-white">
                  <thead className="text-sm font-bold border-b-[1px] dark:border-none">
                    <tr>
                      <th scope="col" className="py-3 px-6">
                        S/N
                      </th>
                      <th scope="col" className="py-3 px-6"></th>
                      <th scope="col" className="py-3 px-6">
                        Name
                      </th>
                      <th scope="col" className="py-3 px-6">
                        Position
                      </th>
                      <th scope="col" className="py-3 px-6">
                        Created On
                      </th>
                      {/* <th scope="col" className="py-3 px-6">
                        Phone Number
                      </th> */}
                      <th scope="col" className="py-3 px-6">
                        Status
                      </th>
                      <th scope="col" className="py-3 px-6">
                        Adjust
                      </th>
                    </tr>
                  </thead>
                  <Droppable droppableId="package">
                    {(provided) => (
                      <tbody
                        className="package text-sm"
                        ref={provided.innerRef}
                        {...provided.droppableProps}
                      >
                        {packages?.map((pack, index) => (
                          <Draggable
                            draggableId={pack?.package_name}
                            index={index}
                            key={pack.id}
                          >
                            {(provided) => (
                              <tr
                                className="bg-white dark:bg-[#121212] border-b dark:border-none text-sm cursor-pointer"
                                ref={provided.innerRef}
                                {...provided.draggableProps}
                              >
                                <td className="py-4 px-6">{index + 1}</td>
                                <td className="p-4 w-4">
                                  <div className="flex items-center">
                                    {/* <input
                                      id="checkbox-table-search-1"
                                      type="checkbox"
                                      className="w-4 h-4 text-primary bg-gray-100 rounded border-gray-300"
                                    />
                                    <label
                                      htmlFor="checkbox-table-search-1"
                                      className="sr-only"
                                    >
                                      checkbox
                                    </label> */}
                                    <CheckBox
                                      setPosition={setPosition}
                                      setShowModal={setShowModal}
                                      setSelectId={setSelectId}
                                      selectId={selectId}
                                      position={pack?.position}
                                      pack_id={pack?.id}
                                    />
                                  </div>
                                </td>
                                <td className="py-4 px-6">
                                  {pack?.package_name}
                                </td>
                                <td className="py-4 px-6">{pack?.position}</td>
                                <td className="py-4 px-6">
                                  {moment(pack?.created_at).format(
                                    "MMM DD, YYYY"
                                  )}
                                </td>
                                {/* <td className="py-4 px-6">
                                  {pack.package_phone}
                                </td> */}
                                <td className="py-4 px-6">
                                  {pack?.business_approved === true ? (
                                    <span className="text-[#00D220] font-bold">
                                      Active
                                    </span>
                                  ) : (
                                    <span className="text-primary font-bold">
                                      Inactive
                                    </span>
                                  )}
                                </td>

                                <td
                                  className="py-4 px-6"
                                  {...provided.dragHandleProps}
                                >
                                  {
                                    <img
                                      className="cursor-pointer"
                                      src={Adjust}
                                      alt="adjust"
                                    ></img>
                                  }
                                </td>
                              </tr>
                            )}
                          </Draggable>
                        ))}
                        {provided.placeholder}
                      </tbody>
                    )}
                  </Droppable>
                </table>
              </DragDropContext>
            ) : (
              <div className="py-36 text-center">
                <div className="flex justify-center">
                  <img src={EmptyState} className="w-auto" alt="no data" />
                </div>
                <h3 className="mt-5 text-xl font-bold">Packages</h3>
                <p className="mt-2 text-sm text-[#9CA3AF]">
                  You have not added any packages yet.
                </p>
              </div>
            )}

            <Pagination
              data={allPackages}
              route={"admin/settings/arrangement/package"}
            />
          </div>
        )}

        {active_tab === "searched" && (
          <div className="bg-white dark:bg-[#121212] rounded-md py-4">
            {searching ? (
              <TableSkeleton />
            ) : (
              <DragDropContext onDragEnd={(results) => handleDragEnd(results)}>
                <table className="sm:w-full sm:inline-table text-left text-[#151515] dark:text-white">
                  <thead className=" text-sm font-bold">
                    <tr>
                      <th scope="col" className="py-3 px-6">
                        S/N
                      </th>
                      <th scope="col" className="py-3 px-6"></th>
                      <th scope="col" className="py-3 px-6">
                        Name
                      </th>
                      <th scope="col" className="py-3 px-6">
                        Created On
                      </th>
                      {/* <th scope="col" className="py-3 px-6">
                        Phone Number
                      </th> */}
                      <th scope="col" className="py-3 px-6">
                        Status
                      </th>
                    </tr>
                  </thead>
                  <Droppable droppableId="package">
                    {(provided) => (
                      <tbody
                        className="package text-sm"
                        ref={provided.innerRef}
                        {...provided.droppableProps}
                      >
                        {search?.data?.map((pack, index) => (
                          <Draggable
                            draggableId={pack?.package_name}
                            index={index}
                            key={pack.id}
                          >
                            {(provided) => (
                              <tr
                                className="bg-white dark:bg-[#121212] border-b dark:border-none text-sm cursor-pointer"
                                ref={provided.innerRef}
                                {...provided.draggableProps}
                              >
                                <td className="py-4 px-6">{index + 1}</td>
                                <td className="p-4 w-4">
                                  <div className="flex items-center">
                                    <CheckBox
                                      setPosition={setPosition}
                                      setShowModal={setShowModal}
                                      setSelectId={setSelectId}
                                      selectId={selectId}
                                      position={pack?.position}
                                      pack_id={pack?.id}
                                    />
                                  </div>
                                </td>
                                <td className="py-4 px-6">
                                  {pack.package_name}
                                </td>
                                <td className="py-4 px-6">
                                  {moment(pack?.created_at).format(
                                    "MMM DD, YYYY"
                                  )}
                                </td>
                                {/* <td className="py-4 px-6">
                                  {pack.package_phone}
                                </td> */}
                                <td className="py-4 px-6">
                                  {pack?.business_approved === true ? (
                                    <span className="text-[#00D220]">
                                      Active
                                    </span>
                                  ) : (
                                    <span className="text-primary">
                                      Inactive
                                    </span>
                                  )}
                                </td>
                              </tr>
                            )}
                          </Draggable>
                        ))}
                        {provided.placeholder}
                      </tbody>
                    )}
                  </Droppable>
                </table>
              </DragDropContext>
            )}
          </div>
        )}
      </div>
      {showModal && (
        <div className="absolute top-0 bottom-0 h-full w-full bg-gray-500 bg-opacity-75 transition-opacity">
          <div className="relative bg-white dark:bg-[#121212] mt-20 mx-auto w-[990px] rounded-md py-5 px-8 flex justify-around">
            <button
              type="button"
              className="text-black block absolute top-5 right-5"
              onClick={() => {
                setShowModal(false);
                setSelectId("");
              }}
            >
              <span className="sr-only">Close</span>
              <img src={CLOSE} alt="close" className=" w-3 h-3" />
            </button>
            <Input.Label
              title={"Current Position"}
              className={"w-80"}
              defaultValue={position}
              disabled
            />

            <Input.Number
              title={"New Position"}
              htmlFor="position"
              name="position"
              onChange={(e) => setData(e.target.value)}
              className={"w-80"}
            />
            <Button.Primary
              title={arranging ? <Beat /> : "Change Position"}
              disabled={arranging}
              className={"h-11 mt-6"}
              onClick={handlePosition}
            />
          </div>
        </div>
      )}
    </div>
  );
}
